import { WhatsappStruct } from './whatsapp.struct';

export class EmpresaWhatsappStruct {
  idEmpresa: number;
  listaWhatsapps: WhatsappStruct[] = [];
}
